import { MapAccessRequestAuth as View } from 'ui-components'
import { useAuth, useFederatedAuth } from 'user-auth'

export function MapAccessRequestAuth() {
  const { user } = useAuth()
  const { signOut } = useFederatedAuth()

  const handleSignInClick = () => {
    signOut({
      preventRedirect: true
    })
  }

  return (
    <View
      user={user}
      onSignInClick={handleSignInClick}
    />
  )
}
